import { axInst, axInstBasic } from "../Service/Service";

export const fetchvehicle = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}total_vehicles_card`,
            payload
        );

        // Add response validation
        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        // Better error handling
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};



export const fetchdealertheybuyfrom = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}dealer-they-buy-from`,
            payload
        );

        // Add response validation
        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};





export const fetchcustomerrelationshipage = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}customer_relationship_age`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result || [];
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};



export const fetchcitycount = async (payload) => {

    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getCityCount`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};



export const fetchcitylist = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getCityList`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};



export const fetchgetDealerList = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getDealerList`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};

export const fetchtotalfleetid = async (payload) => {
    try {
        const res = await axInst.post(
            `${process.env.REACT_APP_API_URL}getFleetIdCount`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};


export const fetchReferralProspects = async (payload) => {
    try {
        const res = await axInst.post(
            `${process.env.REACT_APP_API_URL}getReferralProspects`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};

export const fetchgetReferralData = async (payload) => {
    try {
        const res = await axInst.post(
            `${process.env.REACT_APP_API_URL}getReferralData`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};


export const fetchgetOptyCount = async (payload) => {
    try {
        const res = await axInst.post(
            `${process.env.REACT_APP_API_URL}getOptyCount`,
            payload
        );

        if (!res.data || res.data.result === undefined) {
            throw new Error("Invalid response format");
        }

        return res.data.result;
    } catch (error) {
        if (error.name === 'AbortError') {
            // console.log('Request was cancelled');
            throw error;
        }
    }
};